<template>
  <div class="plan-builder">
    <div class="plan-builder-content">
      <plan-display />
      <float-panel
        id="tool-selector"
        title="Инстр."
        dx="0"
        dy="0"
        dw="5"
        dh="100"
      >
        <tool-selector />
      </float-panel>
      <float-panel
        id="object-props"
        title="Свойства"
        dx="90"
        dy="0"
        dw="10"
        dh="100"
      >
        <prop-control />
      </float-panel>
      <!-- компонент настройки линейки -->
      <float-panel
        id="ruller-props"
        title="Линейка"
        dx="5"
        dy="0"
        dw="10"
        dh="75"
        :visible="visibleSidebarMenu === 'ruller'"
        closable="true"
        @visibility="() => setSidebarMenu('ruller')"
      >
        <ruller-control />
      </float-panel>
      <float-panel
        id="wall-constructor-panel"
        title="Конструктор стен"
        dx="5"
        dy="0"
        dw="15"
        dh="75"
        :visible="visibleSidebarMenu === 'wall'"
        closable="true"
        @visibility="() => setSidebarMenu('wall')"
      >
        <wall-control />
      </float-panel>
    </div>
    <preloader
      ref="loader"
      :show="preloader"
    />
  </div>
</template>
<style lang="scss">
.plan-builder {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  .plan-builder-content {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
}
</style>
<script>
import floatPanel from './floatPanel.vue'
import toolSelector from './tool-selector.vue'
//import layerSelector from './layerSelector.vue';
import planDisplay from './planDisplay.vue'
import propControl from './prop-control.vue'
import preloader from '@/lib/vendor/eve/components/local-preloader.vue'
import { central_data } from '@/lib/vendor/eve/planhub/lib-central-data'
import events from '@/lib/vendor/eve/planhub/lib-events'
import U from '@/lib/vendor/eve/lib-utils'
import rullerControl from './rullerControl.vue'
import wallControl from './wall-constructor/wallControl.vue'
export default {
  name: 'plan-builder',
  components: {
    floatPanel: floatPanel,
    toolSelector: toolSelector,
    preloader: preloader,
    planDisplay: planDisplay,
    propControl: propControl,
    rullerControl: rullerControl,
    wallControl: wallControl,
    //  objectProps: objectProps,
    // levelList: levelList,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      preloader: false,
      visibleSidebarMenu: null,
      rullerVisible: false,
      wallConstructorVisible: false,
    }
  },
  methods: {
    getRullerIsActive: function () {
      var c = {}
      central_data().lem.run(events._RULLER_STATUS, c)
      return U.any_bool(c.status, false)
    },
    onClearRuller: function () {
      central_data().lem.run(events._RULLER_CLEAR)
      this.setup_header()
    },
    onRullerButton: function () {
      this.onClearRuller()
      central_data().lem.run(events._RULLER_ACTIVATE)
    },
    setSidebarMenu: function (sidebarName) {
      this.$data.visibleSidebarMenu =
        this.$data.visibleSidebarMenu !== sidebarName ? sidebarName : null
      localStorage.setItem(
        'visible-sidebar-menu',
        this.$data.visibleSidebarMenu,
      )

      if (this.$data.visibleSidebarMenu === 'wall') {
        central_data().lem.run(events._WALL_ACTIVATE)
      } else {
        central_data().lem.run(events._WALL_DEACTIVATE)
      }
    },
    showLoader: function () {
      try {
        this.$refs.loader.show()
      } catch (e) {
        this.$data.preloader = true
      }
    },
    hideLoader: function () {
      try {
        this.$refs.loader.hide()
      } catch (e) {
        this.$data.preloader = false
      }
    },
    setup_header: function () {
      central_data().set_ui_state('APP-HEADER', {
        title: 'Проект "' + central_data().project.header.name + '"',
        buttons: [
          {
            hint: 'Сохранить',
            message: 'project-save',
            icon_html: require('!!raw-loader!@/svg/common/flop.svg').default,
          },
          {
            hint: 'Скачать',
            message: 'project-down',
            icon_html: require('!!raw-loader!@/svg/common/download.svg')
              .default,
          },
          // {
          //   hint: 'Объекты',
          //   message: 'objects',
          //   icon_html: require('!!raw-loader!@/svg/objects/objects-icon.svg')
          //     .default,
          //   // hilight: this.getRullerIsActive(),
          // },
          {
            hint: 'Линейка',
            message: 'ruller',
            icon_html: require('!!raw-loader!@/svg/ruller/ruller-icon.svg')
              .default,
            hilight: this.getRullerIsActive(),
          },
          {
            hint: 'Очистить слой линейки',
            message: 'clear-ruller',
            icon_html: require('!!raw-loader!@/svg/ruller/ruller-icon.svg')
              .default,
          },
          {
            hint: 'Настройки линейки',
            message: 'ruller-setup',
            icon_html: require('!!raw-loader!@/svg/ruller/ruller-setup.svg')
              .default,
            hilight: this.$data.rullerVisible,
          },
          {
            hint: 'Конструктор стен',
            message: 'wall-constructor',
            icon_html: require('!!raw-loader!@/svg/wall-constructor/wall.svg')
              .default,
            hilight: this.$data.visibleSidebarMenu === 'wall',
          },
        ],
      })
    },
    do_save: function () {
      this.showLoader()
      central_data().save_project()
    },
    do_down: function () {
      this.showLoader()
      central_data().create_drawing(this.down_ready.bindTo(this))
    },
    down_ready: function (dataUrl) {
      var link = document.createElement('a')
      link.download = [central_data().project.header.name, '.jpg'].join('')
      link.href = dataUrl
      link.style.display = 'none'
      var bd = document.getElementsByTagName('body')
      if (bd.length) {
        bd.item(0).appendChild(link)
      }
      link.click()
      window.setTimeout(function () {
        if (bd.length) {
          bd[0].removeChild(link)
        }
      })
      this.hideLoader()
    },
  },
  created: function () {
    this.$data.rullerVisible = U.any_bool(
      localStorage.getItem('ruller-setup-panel-visible'),
      true,
    )
    this.$data.wallConstructorVisible = U.any_bool(
      localStorage.getItem('wall-constructor-panel-visible'),
      true,
    )
    central_data().lem.clear_event('project-save')
    central_data().lem.clear_event('project-down')
    central_data()
      .on(events._PROJECT_CHANGED, this, function () {
        this.showLoader()
        central_data().load_project(central_data().project_id)
      })
      .on(events._PROJECT_LOAD_FAIL, this, this.hideLoader.bindTo(this))
      .on(events._PROJECT_LOAD_COMPLETE, this, this.hideLoader.bindTo(this))
      .on(events._PROJECT_LOAD_COMPLETE, this, this.setup_header.bindTo(this))
      .on('project-save', this, this.do_save)
      .on('project-down', this, this.do_down)
      .on('ruller-setup', this, () => this.setSidebarMenu('ruller'))
      .on('wall-constructor', this, () => this.setSidebarMenu('wall'))
      .on('clear-ruller', this, this.onClearRuller)
      .on('ruller', this, this.onRullerButton)
      .on(events._RULLER_STATUS_CHANGED, this, this.setup_header)
      .on(events._WALL_STATUS_CHANGED, this, this.setup_header)

    if (this.$data.visibleSidebarMenu === 'wall') {
      central_data().lem.run(events._WALL_ACTIVATE)
    } else {
      central_data().lem.run(events._WALL_DEACTIVATE)
    }
  },
  mounted: function () {
    this.showLoader()
    if (this.$props.id) {
      central_data().load_project(this.$props.id)
    }

    this.visibleSidebarMenu = localStorage.getItem('visible-sidebar-menu')
  },
}
</script>
